import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Card,
  Typography,
  Button,
  Backdrop,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Paper,
  Chip,
  ListItemIcon,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../components/dashboard_layout";
import axios from "../../axios";
import AppConfig from "../../appConfig";

function ApplicationViewPage() {
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [application, setApplication] = useState(null);
  const [allocations, setAllocations] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`practitioners/applications/${ref}/fetch.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setApplication(result.data.data.application);
            setAllocations(result.data.data.application.allocations);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getStatusColor(status) {
    if (status === "approved") {
      return "success";
    } else if (status === "denied") {
      return "error";
    } else {
      return "warning";
    }
  }
  return (
    <DashboardLayout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box>
        <Box mb={3}>
          <Button
            startIcon={<Icon>chevron_left</Icon>}
            onClick={() => navigate("/applications")}
          >
            Back
          </Button>
        </Box>
        {application !== null ? (
          <Paper elevation={2}>
            <Box p={3}>
              <Box px={1} mb={3}>
                <Typography variant="subtitle1" fontWeight={400}>
                  Application
                </Typography>
                <Divider />
              </Box>
              <Box display="flex" direction="row" justifyContent="space-evenly">
                <Box sx={{ width: "100%" }}>
                  <ListItem>
                    <ListItemIcon>
                      <Icon>receipt</Icon>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="subtitle1" fontSize={16}>
                          ID: {application.reference}
                        </Typography>
                      }
                      secondary={`Applied On: ${application.created}`}
                    />
                    {/* <Box align="right" mb={0}>
                      <Box mt={0}>
                        <Chip
                          label={!application.closed ? application.status : "closed"}
                          variant="outlined"
                          color={!application.closed ? getStatusColor(application.status) : "default"}
                        />
                        <Typography mt={1} variant="body2">
                          {application.status_message}
                        </Typography>
                      </Box>
                    </Box> */}
                  </ListItem>
                  <Divider />
                </Box>
              </Box>
              <Box mt={10} px={1}>
                <Typography variant="subtitle1" fontWeight={400}>
                  Roads
                </Typography>
                <Divider />
              </Box>
              <Box mt={3}>
                {application.items.map((item) => (
                  <Box
                    display="flex"
                    direction="row"
                    justifyContent="space-evenly"
                  >
                    <Box sx={{ width: "100%" }}>
                      <ListItem>
                        <ListItemIcon>
                          <Icon>add_road</Icon>
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Box>
                              <Typography
                                variant="subtitle2"
                                fontSize={12}
                                fontWeight={400}
                              >
                                {item.category}
                              </Typography>
                              <Typography variant="subtitle2">
                                {item.road}
                              </Typography>
                            </Box>
                          }
                          secondary={`Poles: ${item.quantity}`}
                        />
                        <Box align="center" mb={0}>
                          <Box mt={0}>
                            <Chip
                              size="small"
                              label={item.status.toUpperCase()}
                              variant="outlined"
                              color={getStatusColor(item.status)}
                            />
                          </Box>
                        </Box>
                      </ListItem>
                      <Divider />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Paper>
        ) : (
          <> </>
        )}
        {allocations.length > 0 ? (
          <Box mt={5}>
            <Paper elevation={2}>
              <Box p={3}>
                <Box px={1}>
                  <Box mb={1} display="flex" justifyContent="space-between">
                    <Typography variant="subtitle1" fontWeight={400}>
                      Allocations
                    </Typography>
                  </Box>
                  <Divider />
                </Box>
                <Box mt={3}>
                  {allocations.map((allocation) => (
                    <Box
                      display="flex"
                      direction="row"
                      justifyContent="space-evenly"
                    >
                      <Box sx={{ width: "100%" }}>
                        <ListItem>
                          <ListItemIcon>
                            <Icon>add_road</Icon>
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <Typography variant="subtitle2">
                                {allocation.road}
                              </Typography>
                            }
                            secondary={`Poles: ${allocation.quantity}`}
                          />
                          <Box align="center" mb={0}>
                            <Box mt={0}>
                              {!allocation.paid ? (
                                <Button
                                  startIcon={<Icon>payment</Icon>}
                                  variant="contained"
                                  color="success"
                                  size="small"
                                  onClick={() => {
                                    var url = `${AppConfig.api_base_url}invoices/${allocation.reference}?nocache=${(new Date()).getTime()}`;
                                    window.open(url, "_blank");
                                  }}
                                >
                                  Preview Invoice
                                </Button>
                              ) : (
                                <Button
                                  startIcon={<Icon>check</Icon>}
                                  variant="contained"
                                  color="info"
                                  size="small"
                                  onClick={() => {
                                    var url = `${AppConfig.api_base_url}allocation/letter/${allocation.reference}?nocache=${(new Date()).getTime()}`;
                                    window.open(url, "_blank");
                                  }}
                                >
                                  Approval Letter
                                </Button>
                              )}
                            </Box>
                          </Box>
                        </ListItem>
                        <Divider />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Paper>
          </Box>
        ) : (
          <> </>
        )}
      </Box>
    </DashboardLayout>
  );
}

export default ApplicationViewPage;
